<div id="dialog_container" class="small-dialog-container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="center-band center">
    <img
      id="warning_icon"
      src="/assets/images/warning-icon.svg"
      alt="Warning"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">Edit {{ type() }}</div>
      <div id="message" class="message">Are you sure you want to edit {{ type() }}?</div>
      @if (!editEnabled()) {
        <span>You will be able to edit {{ type() }} after {{ startCount() }} second(s)</span>
      }
      @if (editEnabled()) {
        <span>You can now edit {{ type() }}!</span>
      }
    </span>
  </div>
  <hr class="custom-hr" />
  <div id="lower_band" class="lower-band">
    <button
      mat-button
      id="cancel_button"
      class="blue-button common-button"
      (click)="dialog.close()">
      Cancel
    </button>
    <button
      mat-button
      id="edit_button"
      class="white-button common-button"
      [ngClass]="{ inactive: !editEnabled() }"
      [disabled]="!editEnabled()"
      (click)="dialog.close(confirmation.confirm)">
      Edit
    </button>
  </div>
</div>
